import React from 'react';
import Icon from '@projeccions-pdc/react-icon';
import * as cx from 'classnames';
import BreadcrumbsController from '../BreadcrumbsController';
import { isSmartphone, getLocalizedName } from '../../../helpers';
import queryString from 'query-string';
import AppContext from '../../../AppContext';
import { CollectionIcon, MeetingsIcon } from '../../Search/Search';
import { Link } from 'react-router-dom';
import './Breadcrumbs.css';
import AccountTreeIcon from '@material-ui/icons/AccountTree';

let smartphoneStyle = {
    display: 'inline-block',
    color: '#000',
    width: '30px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
};
let normalStyle = {
    display: 'inline-block',
    color: '#000',
    verticalAlign: 'middle',
    marginRight: '0.2rem',
};

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this._BreadcrumbsController = new BreadcrumbsController(this);
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    componentDidMount() {
        isSmartphone((match) => this.handleSizeChange(match));
    }

    static getDerivedStateFromProps(props, state) {
        let newState = null;

        let contentId = undefined;
        if ([undefined, 'category', 'metadocument'].indexOf(props.match.params.func) !== -1) {
            contentId = props.match.params.contentId;
        } else if (['fileviewer', 'library'].indexOf(props.match.params.func) !== -1) {
            contentId = state.contentId;
        }

        if (contentId && contentId.indexOf('$') !== -1) {
            let aux = contentId.split('$');
            contentId = aux[0];
        }

        if (state.contentId !== contentId) {
            newState = Object.assign({}, newState, {
                contentId,
                oldContentId: state.contentId,
            });
        }

        if (props.preDefinedPath && props.preDefinedPath[0].contentId === contentId) {
            let breadcrumbs = props.preDefinedPath.reverse();
            newState = Object.assign({}, newState, {
                breadcrumbs,
            });
        }

        const parsed = queryString.parse(props.location.search);
        if (parsed.mtg) {
            newState = Object.assign({}, newState, {
                mtg: parsed.mtg,
            });
        }
        if (parsed.col) {
            newState = Object.assign({}, newState, {
                col: parsed.col,
            });
        }

        return newState;
    }

    componentDidUpdate() {
        if (this.state.oldContentId !== this.state.contentId) {
            this.loadData();
        }
    }

    loadData = async () => {
        let newState = await this._BreadcrumbsController.loadBaseData(this.state.contentId, this.props.inside, this.state.breadcrumbs);
        this.setState(newState);
    };

    render = () => {
        let appContext = new AppContext();
        let language = appContext.getLanguage();

        let to, icon;
        if (this.state.mtg) {
            to = `/metadocument/show/${this.state.mtg}`;
            icon = MeetingsIcon;
        } else if (this.state.col) {
            to = `/metadocument/show/${this.state.col}`;
            icon = CollectionIcon;
        } else {
            to = this.props.inside ? '/category/show/' : '/category/edit/';
            // icon = 'md-home'; // WARNING IT IS REPLACED BELOW!
            icon = 'md-format-list-bulleted'; // WARNING IT IS REPLACED BELOW!
        }

        let paddingStyle = {};
        if (this.state.breadcrumbs === undefined || this.state.breadcrumbs.length < 1) {
            paddingStyle = {
                paddingRight: '0px',
            };
        }

        return (
            <div
                className={cx(
                    { breadcrumbs: true },
                    { 'breadcrumbs-wide': !this.props.scrollTop },
                    { 'breadcrumbs-scrollUp': !this.props.scrollUp },
                    { 'breadcrumbs-compact-open': this.props.compactOpen === true }
                )}
                style={{
                    maxWidth: 'calc(100% -  84px - 16px)',
                    ...paddingStyle,
                }}
            >
                <Link to={to}>
                    {icon !== undefined ? (
                        <Icon name={icon} size="28px" padding={7} />
                    ) : (
                        <AccountTreeIcon style={{ fontSize: '28px', color: '#000', padding: 7 }} />
                    )}
                </Link>
                {/* {' | Products | Core Products | '}
                <strong>{'Automotive'}</strong> */}

                {this.state.contentId
                    ? this.state.breadcrumbs
                        ? this.state.breadcrumbs.map((content, idx, array) => {
                              if (content.contentId === 'MAIN-CATEGORY') {
                                  return null;
                              }

                              let isLast = false;
                              if (idx === array.length - 1) {
                                  isLast = true;
                              }

                              let nameComponent = (
                                  <span
                                      dangerouslySetInnerHTML={{ __html: getLocalizedName(language, content.names) }}
                                      style={this.state.smartphoneView !== true || idx === array.length - 1 ? normalStyle : smartphoneStyle}
                                  />
                              );

                              return (
                                  <span key={content.contentId} data-id="breadcrumbs-item">
                                      {'| '}
                                      <Link
                                          to={
                                              this.props.inside
                                                  ? content.objectType === 'c'
                                                      ? '/category/show/' + content.contentId
                                                      : '/metadocument/show/' + content.contentId
                                                  : content.objectType === 'c'
                                                  ? '/category/edit/' + content.contentId
                                                  : '/metadocument/edit/' + content.contentId
                                          }
                                      >
                                          {isLast === true ? <strong>{nameComponent}</strong> : nameComponent}
                                      </Link>{' '}
                                  </span>
                              );
                          })
                        : ''
                    : ''}
            </div>
        );
    };
}

export default App;
